import { usePostPortfolioInvestmentMutation } from "web_myplann/Api/Portfolio/Mutations/usePostPortfolioInvestmentMutation";
import { Routing } from "web_myplann/Infrastructure/Routing/Routing";
import { useResource } from "web_myplann/Infrastructure/Translations/Resources";
import { getInvestmentCreateFormDefaultValues } from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormDefaults";
import {
	getInvestmentCreateFormSchema,
	type InvestmentCreateFormOutput,
} from "web_myplann/Portfolio/Forms/InvestmentForm/investmentFormSchema";
import { mapInvestmentCreateFormToRequest } from "web_myplann/Portfolio/Forms/InvestmentForm/mapInvestmentFormToRequest";
import { useCreatePortfolioForm } from "web_myplann/Portfolio/PortfolioShared/useCreatePortfolioForm";

export const useCreateInvestmentForm = () => {
	const { t } = useResource();
	const { mutate, isPending } = usePostPortfolioInvestmentMutation();

	const { form, onSubmit } = useCreatePortfolioForm({
		schema: getInvestmentCreateFormSchema(t),
		defaultValues: getInvestmentCreateFormDefaultValues(),
		mutate: (data: InvestmentCreateFormOutput, options) => {
			mutate(mapInvestmentCreateFormToRequest(data), options);
		},
		successRoute: Routing.Portfolio.PortfolioAddInvestmentSuccess.path(),
	});

	return { form, onSubmit, isPending };
};
